import { useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../../services/api";

import "./ForgotPassword.css";

import RegisterHeader from "../../components/auth/RegisterHeader";
import OTPSection from "../../components/auth/OTPSection";
import PasswordSection from "../../components/auth/PasswordSection";

function ForgotPassword() {

  const navigate = useNavigate();

  const [email, setEmail] = useState("");

  const [role, setRole] = useState("customer");

  const [otp, setOtp] = useState([
    "",
    "",
    "",
    "",
    "",
    ""
  ]);

  const [passwordForm, setPasswordForm] = useState({
    password: "",
    confirmPassword: ""
  });

  const [otpSent, setOtpSent] = useState(false);

  const [otpVerified, setOtpVerified] = useState(false);

  const [loading, setLoading] = useState(false);

  const [status, setStatus] = useState("");

  const [statusType, setStatusType] = useState("");

  // ==========================
  // Send OTP
  // ==========================

  const sendOTP = async () => {

    if (!email) {

      setStatus("Enter your email.");

      setStatusType("error");

      return;

    }

    try {

      setLoading(true);

      await API.post(

    "/auth/send-email-otp",

    {

        email,

        type:

            role === "customer"

                ? "customer-forgot-password"

                : role === "provider"

                ? "provider-forgot-password"

                : "delivery-forgot-password",

    }

);

      setOtpSent(true);

      setStatus("OTP Sent Successfully");

      setStatusType("success");

    }

    catch (error) {

      setStatus(

        error.response?.data?.message ||

        "Failed to send OTP"

      );

      setStatusType("error");

    }

    finally {

      setLoading(false);

    }

  };

  // ==========================
  // Verify OTP
  // ==========================

  const verifyOTP = async () => {

    try {

      await API.post(

        "/auth/verify-email-otp",

        {

          email,

          otp: otp.join("")

        }

      );

      setOtpVerified(true);

      setStatus("OTP Verified");

      setStatusType("success");

    }

    catch (error) {

      setStatus(

        error.response?.data?.message ||

        "OTP Verification Failed"

      );

      setStatusType("error");

    }

  };

  // ==========================
  // Password Change
  // ==========================

  const handleChange = (e) => {

    setPasswordForm({

      ...passwordForm,

      [e.target.name]: e.target.value

    });

  };

  const resetPassword = async () => {

    if (

      passwordForm.password !==

      passwordForm.confirmPassword

    ) {

      setStatus("Passwords do not match");

      setStatusType("error");

      return;

    }

    try {

      await API.post(

        "/auth/reset-password",

        {

          email,

          password: passwordForm.password

        }

      );

      alert("Password Updated Successfully");

      navigate("/login");

    }

    catch (error) {

      setStatus(

        error.response?.data?.message ||

        "Password Reset Failed"

      );

      setStatusType("error");

    }

  };

  return (

    <div className="customer-register">

      <div className="customer-card">

        <RegisterHeader />

        <h2>

          Forgot Password

        </h2>

        {status && (

          <div

            className={`status-message ${statusType}`}

          >

            {status}

          </div>

        )}

        {!otpSent && (

          <>


            <div className="input-group">
              

    <select
        value={role}
        onChange={(e) => setRole(e.target.value)}
    >

        <option value="customer">
            Customer
        </option>

        <option value="provider">
            Provider
        </option>

        <option value="delivery">
            Delivery Partner
        </option>

    </select>



              <input

                type="email"

                placeholder=" "

                value={email}

                onChange={(e)=>

                  setEmail(

                    e.target.value

                  )

                }

              />

              <label>

                Email Address

              </label>

            </div>

            <button

              onClick={sendOTP}

            >

              Send OTP

            </button>

          </>

        )}

        {otpSent && !otpVerified && (

          <OTPSection

            otp={otp}

            setOtp={setOtp}

            verifyOTP={verifyOTP}

          />

        )}

        {otpVerified && (

          <PasswordSection

    form={passwordForm}

    handleChange={handleChange}

    createAccount={resetPassword}

    loading={loading}

    buttonText="Update Password"

/>

        )}

      </div>

    </div>

  );

}

export default ForgotPassword;